import request from './request'

// 获取设备列表
export function getZoneList (data) {
  return request.get('en/zone/list', data)
}
// 新增设备
export function addZone (data) {
  return request.post('en/zone/add', data, 'json')
}
// 修改
export function updateZone (data) {
  return request.post('en/zone/update', data, 'json')
}
// 删除
export function deleteZone (data) {
  return request.post('en/zone/delete', data)
}
// 批量保存
export function patchUpdateZone (data) {
  return request.post('en/zone/patchUpdate', data, 'json')
}
// 批量保存
export function patchGroupUpdate (data) {
  return request.post('en/zone/patchGroupUpdate', data, 'json')
}
